export default __webpack_public_path__ + "static/media/img-01.ce0cf990.png";